<template>
  <div class="d-flex justify-content-end">
    <!-- <div class="d-flex gap-2"> -->
    <McTableFilter
      :activeFilters="activeFilters"
      :parseFilterDataMappings="parseFilterDataMappings"
      @submit="handleInput"
    >
      <template #content="{ formValues, updateFormValues, fullObjects, updateFullObjects }">
        <div class="mc-modal__filter-item">
          <FormulateInput
            name="fleetType"
            :label="$t('global.field.vehicleType')"
            :placeholder="$t('global.field.vehicleType')"
            :multiple="true"
            type="value-help-v2"
            trackBy="vehicleTypeId"
            :displayedBy="'type'"
            :listGetter="resourcefulQuery.fleetType"
            :tableFields="typeTableFields"
            :fullObject="fullObjects['fleetType']"
            @update:formValues="updateFormValues({ key: 'fleetType', value: $event })"
            @update:fullObject="updateFullObjects({ key: 'fleetType', value: $event })"
            :value="formValues.fleetType"
          >
          </FormulateInput>
        </div>
        <div class="mc-modal__filter-item">
          <FormulateInput
            name="fleetCategory"
            :label="$t('global.object.fleetCategory')"
            :placeholder="$t('global.object.fleetCategory')"
            :multiple="true"
            trackBy="category"
            :displayedBy="'category'"
            :tableFields="categoryTableFields"
            type="value-help-v2"
            :listGetter="resourcefulQuery.fleetCategory"
            :fullObject="fullObjects['fleetCategory']"
            @update:formValues="updateFormValues({ key: 'fleetCategory', value: $event })"
            @update:fullObject="updateFullObjects({ key: 'fleetCategory', value: $event })"
            :value="formValues.fleetCategory"
          >
          </FormulateInput>
        </div>
        <div class="mc-modal__filter-item">
          <FormulateInput
            type="group"
            name="serviceLocationType"
            :label="$t('maintenance.order.serviceLocationType')"
            :value="(formValues.serviceLocationType = serviceLocType[0])"
          >
            <div class="mc-modal__filter-button-group">
              <button
                type="button"
                @click="filterServiceLocation('internal')"
                :class="{ 'mc-modal__filter-button--active': serviceLocation.internal }"
                class="mc-modal__filter-button"
              >
                {{ $t('maintenance.order.filter.internal') }}
              </button>
              <button
                type="button"
                @click="filterServiceLocation('eksternal')"
                :class="{ 'mc-modal__filter-button--active': serviceLocation.eksternal }"
                class="mc-modal__filter-button"
              >
                {{ $t('maintenance.order.filter.external') }}
              </button>
            </div>
          </FormulateInput>
        </div>

        <div class="mc-modal__filter-item">
          <FormulateInput
            name="serviceLocation"
            :label="$t('maintenance.order.serviceLocation')"
            :placeholder="$t('maintenance.order.serviceLocation')"
            :multiple="true"
            trackBy="geofenceId"
            :displayedBy="'fenceName'"
            :tableFields="locationTableFields"
            type="value-help-v2"
            :listGetter="resourcefulQuery.location"
            :fullObject="fullObjects['serviceLocation']"
            @update:formValues="updateFormValues({ key: 'serviceLocation', value: $event })"
            @update:fullObject="updateFullObjects({ key: 'serviceLocation', value: $event })"
            :value="formValues.serviceLocation"
          >
          </FormulateInput>
        </div>

        <div class="mc-modal__filter-item">
          <FormulateInput
            name="startServicePeriode"
            :label="$t('maintenance.order.startServicePeriode')"
            type="date-picker"
            :range="true"
            :format="'DD MMM YYYY'"
            :value-type="'YYYY-MM-DD'"
            :value="formValues.startServicePeriode"
            :placeholder="`${$t('global.form.select')} ${$t('global.field.date')}`"
          >
          </FormulateInput>
        </div>
        <div class="mc-modal__filter-item">
          <FormulateInput
            name="etaServicePeriode"
            :label="$t('maintenance.order.etaServicePeriode')"
            type="date-picker"
            :range="true"
            :format="'DD MMM YYYY'"
            :value-type="'YYYY-MM-DD'"
            :value="formValues.etaServicePeriode"
            :placeholder="`${$t('global.form.select')} ${$t('global.field.date')}`"
          >
          </FormulateInput>
        </div>
        <div class="mc-modal__filter-item">
          <FormulateInput
            name="actualServicePeriode"
            :label="$t('maintenance.order.actualServicePeriode')"
            type="date-picker"
            :range="true"
            :format="'DD MMM YYYY'"
            :value-type="'YYYY-MM-DD'"
            :value="formValues.actualServicePeriode"
            :placeholder="`${$t('global.form.select')} ${$t('global.field.date')}`"
          >
          </FormulateInput>
        </div>
      </template>
    </McTableFilter>

    <div class="ms-2">
      <McButton
        v-if="isSelected"
        @click="showDeleteModal"
        :variant="'secondary-red'"
        :text="$t('global.delete')"
        icon="icon-outline_trash"
      />
    </div>
  </div>
</template>

<script>
import McTableFilter from '@/components/McTableFilter'
import McButton from '@/components/McButton'
import { GET_VEHICLE_TYPE } from '@/services/api/setting/fleet/fleetType'
import { GET_CATEGORY } from '@/services/api/setting/fleet/fleetCat'
import { GET_GEOFENCES } from '@/services/api/master/geofence'

export default {
  components: {
    McTableFilter,
    McButton,
  },

  props: {
    activeFilters: {
      required: true,
    },
    handleChangeActiveFilters: {
      type: Function,
    },
    isSelected: {},
    showDeleteModal: {},
  },

  data() {
    return {
      serviceLocation: {
        internal: false,
        eksternal: false,
      },
      serviceLocType: [],
    }
  },

  computed: {
    typeTableFields() {
      return [
        {
          label: this.$t('global.field.vehicleType'),
          key: 'type',
          isSortable: true,
          isRedirectable: true,
        },
        {
          label: this.$t('global.object.fleetCategory'),
          key: 'category',
          isSortable: true,
          isRedirectable: true,
        },
      ]
    },
    categoryTableFields() {
      return [
        {
          label: this.$t('global.object.fleetCategory'),
          key: 'category',
          isSortable: true,
          isRedirectable: true,
        },
      ]
    },
    locationTableFields() {
      return [
        {
          label: this.$t('global.object.serviceLocation'),
          key: 'fenceName',
          isSortable: true,
          isRedirectable: false,
        },
        {
          label: this.$t('global.object.serviceLoationType'),
          key: 'serviceLocType',
          isSortable: true,
          isRedirectable: false,
        },
        {
          label: this.$t('global.object.city'),
          key: 'city',
          isSortable: true,
          isRedirectable: false,
        },
      ]
    },

    resourcefulQuery() {
      return {
        fleetType: async (opts) => {
          let result = {}

          const filter = {
            pagination: {
              page: opts.page,
              show: opts.limit,
            },
            search: opts.search,
          }

          const res = await this.$apollo.query({
            query: GET_VEHICLE_TYPE,
            fetchPolicy: 'no-cache',
            variables: {
              filter: filter,
            },
          })

          const fleetTypeOptions = res.data.vehicleTypes.vehicleTypes

          result = {
            metadata: {
              total_count: fleetTypeOptions.pagination.total,
              page: fleetTypeOptions.pagination.page,
            },
            data: {
              paginated_result: fleetTypeOptions.data,
            },
          }

          return result
        },
        fleetCategory: async (opts) => {
          let result = {}

          const filter = {
            pagination: {
              page: opts.page,
              show: opts.limit,
            },
            search: opts.search,
          }

          const res = await this.$apollo.query({
            query: GET_CATEGORY,
            fetchPolicy: 'no-cache',
            variables: {
              filter: filter,
            },
          })

          const fleetCategoryOptions = res.data.vehicleCategories.vehicleCategories

          result = {
            metadata: {
              total_count: fleetCategoryOptions.pagination.total,
              page: fleetCategoryOptions.pagination.page,
            },
            data: {
              paginated_result: fleetCategoryOptions.data,
            },
          }

          return result
        },
        location: async (opts) => {
          let result = {}

          const filter = {
            pagination: {
              page: opts.page,
              show: opts.limit,
            },
            search: opts.search,
          }

          const res = await this.$apollo.query({
            query: GET_GEOFENCES,
            fetchPolicy: 'no-cache',
            variables: {
              filter: {
                ...filter,
                isServiceLoc: true,
                serviceLocType: this.serviceLocType,
              },
            },
          })

          const locationOptions = res.data.geofences.geofences

          result = {
            metadata: {
              total_count: locationOptions.pagination.total,
              page: 1,
            },
            data: {
              paginated_result: locationOptions.data,
            },
          }

          return result
        },
      }
    },

    parseFilterDataMappings() {
      return {
        fleetType: 'vehicleTypeId',
        fleetCategory: 'vehicleCategory',
        serviceLocationType: 'locationType',
        serviceLocation: 'geofenceId',
        startServicePeriode: 'startDateRange',
        etaServicePeriode: 'estimatedEndDateRange',
        actualServicePeriode: 'actualEndDateRange',
      }
    },
  },

  methods: {
    handleInput(value) {
      this.$emit('handleChangeActiveFilters', value)
    },

    filterOrderStatus(key) {
      if (key == 'all') {
        this.filterStatus = {
          all: true,
          draft: false,
          confirmation: false,
          inProgress: false,
          validation: false,
          done: false,
          cancel: false,
        }
      } else {
        this.filterStatus.all = false
        this.filterStatus[key] = !this.filterStatus[key]

        let obj = { ...this.filterStatus }
        let objArr = []
        Object.keys(obj).forEach(function (key) {
          if (obj[key]) {
            objArr.push(true)
          }
        })

        if (objArr.length === 6 || objArr.length === 0) {
          this.filterStatus = {
            all: true,
            draft: false,
            confirmation: false,
            inProgress: false,
            validation: false,
            done: false,
            cancel: false,
          }
          return
        }
      }
    },

    filterServiceLocation(key) {
      this.serviceLocation[key] = !this.serviceLocation[key]

      let obj = { ...this.serviceLocation }

      let objArr = []
      Object.keys(obj).forEach(function (key) {
        const capitalKey = key.charAt(0).toUpperCase() + key.slice(1)

        if (obj[key] === true) {
          objArr.push(capitalKey)
        }
      })

      this.serviceLocType = objArr
    },
  },
}
</script>
